import { Box, Typography } from '@mui/material';
import styles from './styles';

const AdminOnMobile = () => {
    return (
        <Typography component="div" sx={styles.mobileScreen}>
            <Box
                data-testid="diathrive_mobile_logo"
                component="img"
                sx={styles.logo}
                alt="Diathrive Logo"
                src="/images/logo.png"
            />
            <Box>
                <Typography data-testid="diathrive_mobile_title" sx={styles.subTitle} component="div">
                    Unable To Access
                    <Typography sx={styles.title}>Admin Portal</Typography>
                </Typography>
                <Typography variant="body1" sx={styles.description}>
                    Please use your desktop browser to access your account for the best experience.
                </Typography>
            </Box>
        </Typography>
    );
};

export default AdminOnMobile;
